import { render, staticRenderFns } from "./PopupNotiError.vue?vue&type=template&id=020b6e84&scoped=true&"
import script from "./PopupNotiError.vue?vue&type=script&lang=ts&"
export * from "./PopupNotiError.vue?vue&type=script&lang=ts&"
import style0 from "./PopupNotiError.vue?vue&type=style&index=0&id=020b6e84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b6e84",
  null
  
)

export default component.exports